import { useEffect } from 'react';

let lockCount = 0;

export const useBodyScrollLock = (isActive: boolean = true): void => {
    useEffect(() => {
        if (!isActive) return;

        lockCount += 1;
        document.body.style.overflow = 'hidden';

        return () => {
            lockCount = Math.max(0, lockCount - 1);
            if (lockCount === 0) {
                document.body.style.overflow = '';
            }
        };
    }, [isActive]);
};

export const resetBodyScrollLock = (): void => {
    lockCount = 0;
    document.body.style.overflow = '';
};
